// extracted by mini-css-extract-plugin
module.exports = {"download-hover-animate":"ApplicationPopper_download-hover-animate__IXJlg","download-container":"ApplicationPopper_download-container___yfG0"};